"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationStatus = exports.AuthorizationType = exports.MessageType = exports.Operator = exports.LogicalConnective = exports.SortOrder = void 0;
/**
 * 排列順序
 */
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["Ascending"] = 0] = "Ascending";
    SortOrder[SortOrder["Descending"] = 1] = "Descending";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
/** 邏輯運算子 */
var LogicalConnective;
(function (LogicalConnective) {
    LogicalConnective[LogicalConnective["And"] = 0] = "And";
    LogicalConnective[LogicalConnective["Or"] = 1] = "Or";
})(LogicalConnective = exports.LogicalConnective || (exports.LogicalConnective = {}));
/** 運算子 */
var Operator;
(function (Operator) {
    Operator[Operator["IsNull"] = 0] = "IsNull";
    Operator[Operator["IsNotNull"] = 1] = "IsNotNull";
    Operator[Operator["Equal"] = 2] = "Equal";
    Operator[Operator["NotEqual"] = 3] = "NotEqual";
    Operator[Operator["GreaterThan"] = 4] = "GreaterThan";
    Operator[Operator["GreaterThanOrEqual"] = 5] = "GreaterThanOrEqual";
    Operator[Operator["LessThan"] = 6] = "LessThan";
    Operator[Operator["LessThanOrEqual"] = 7] = "LessThanOrEqual";
    Operator[Operator["In"] = 8] = "In";
    Operator[Operator["NotIn"] = 9] = "NotIn";
    Operator[Operator["Like"] = 10] = "Like";
    Operator[Operator["NotLike"] = 11] = "NotLike";
    Operator[Operator["Between"] = 12] = "Between";
    Operator[Operator["NotBetween"] = 13] = "NotBetween";
    Operator[Operator["StartsWith"] = 14] = "StartsWith";
    Operator[Operator["EndsWith"] = 15] = "EndsWith";
    Operator[Operator["Contains"] = 16] = "Contains";
    Operator[Operator["NotContains"] = 17] = "NotContains";
})(Operator = exports.Operator || (exports.Operator = {}));
/** 訊息類型 */
var MessageType;
(function (MessageType) {
    /** 追蹤訊息 */
    MessageType[MessageType["Trace"] = 0] = "Trace";
    /** 偵錯訊息 */
    MessageType[MessageType["Debug"] = 1] = "Debug";
    /** 一般訊息 */
    MessageType[MessageType["Info"] = 2] = "Info";
    /** 警告訊息 */
    MessageType[MessageType["Warning"] = 3] = "Warning";
    /** 錯誤訊息 */
    MessageType[MessageType["Error"] = 4] = "Error";
    /** 危急訊息 */
    MessageType[MessageType["Fatal"] = 5] = "Fatal";
    /** 資源 */
    MessageType[MessageType["Resource"] = 6] = "Resource";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
/** 認證類型 */
var AuthorizationType;
(function (AuthorizationType) {
    AuthorizationType[AuthorizationType["Basic"] = 0] = "Basic";
    AuthorizationType[AuthorizationType["Bearer"] = 1] = "Bearer";
})(AuthorizationType = exports.AuthorizationType || (exports.AuthorizationType = {}));
/** 應用程式狀態 */
var ApplicationStatus;
(function (ApplicationStatus) {
    ApplicationStatus[ApplicationStatus["Pendding"] = 0] = "Pendding";
    ApplicationStatus[ApplicationStatus["Running"] = 1] = "Running";
    ApplicationStatus[ApplicationStatus["Stopped"] = 2] = "Stopped";
})(ApplicationStatus = exports.ApplicationStatus || (exports.ApplicationStatus = {}));
